export const RATE_TYPE = {
    FIXED: 'FIXED',
    PER_UNIT: 'PER UNIT',
};

const CALC_TYPE = {
    AMOUNT_FROM_RATE: 'AMOUNT_FROM_RATE',
    RATE_FROM_AMOUNT: 'RATE_FROM_AMOUNT',
    GET_RATE_TYPE: 'GET_RATE_TYPE',
};

const resolveCondition = (pbhCondition, noOfUnits) => {
    if (!pbhCondition?.length) return null;
    const units = parseFloat(noOfUnits) || 0;
    return pbhCondition.find(c => {
        const min = parseFloat(c.min) || 0;
        const max = c.max === '∞' ? Infinity : parseFloat(c.max);
        return units >= min && units <= max;
    }) ?? null;
};

/**
 * Central invoice calculation handler.
 *
 * @param {Object} params
 * @param {'AMOUNT_FROM_RATE'|'RATE_FROM_AMOUNT'|'GET_RATE_TYPE'} params.calcType
 * @param {*} params.invoiceItem  - invoice item with pbh_condition, max_cap, additional_amount
 * @param {number|string} [params.ratePerUnit]
 * @param {number|string} [params.noOfUnits]
 * @param {number|string} [params.subTotal]
 * @returns {number|string|null}
 */
const handleInvoiceCalculation = ({ calcType, invoiceItem, ratePerUnit, noOfUnits, subTotal }) => {
    const units = parseFloat(noOfUnits) || 0;
    const rate = parseFloat(ratePerUnit) || 0;
    const sub = parseFloat(subTotal) || 0;
    const additionalAmount = invoiceItem?.is_additional_amount
        ? parseFloat(invoiceItem?.additional_amount) || 0
        : 0;
    const maxCapApplicable = invoiceItem?.max_cap_applicable;
    const maxCapAmount = parseFloat(invoiceItem?.max_cap_amount) || 0;

    const matched = resolveCondition(invoiceItem?.pbh_condition, units);
    const rateType = matched?.rental_rate_type?.label ?? null;
    const hasPbhCondition = !!invoiceItem?.pbh_condition?.length;

    switch (calcType) {
        case CALC_TYPE.GET_RATE_TYPE:
            return rateType;

        case CALC_TYPE.AMOUNT_FROM_RATE: {
            // FIXED logic preserved — re-enable when needed:
            // if (hasPbhCondition && !matched) return 0;
            // let amount = rateType === RATE_TYPE.FIXED ? rate : units * rate;
            let amount = units * rate;
            if (additionalAmount) amount += additionalAmount;
            if (maxCapApplicable && amount > maxCapAmount) amount = maxCapAmount;
            return parseFloat(amount.toFixed(4));
        }

        case CALC_TYPE.RATE_FROM_AMOUNT: {
            // FIXED logic preserved — re-enable when needed:
            // if (hasPbhCondition && !matched) return null;
            // if (rateType === RATE_TYPE.FIXED) return null;
            const adjusted = sub - additionalAmount;
            return units > 0 ? parseFloat((adjusted / units).toFixed(17)) : 0;
        }

        default:
            return null;
    }
};

export { handleInvoiceCalculation, CALC_TYPE };
